export default function CRecursion() {
  return <h2>C Recursion</h2>;
}
